import styled from "styled-components";

export const TippingHistoryRecordMiddleSectionBox = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-self: stretch;
    justify-content: center;
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
      margin-bottom: 10px;
    }
`